<template>
    <div
        class="container"
        v-if="
            inListChangeOptions.data.length || outListChangeOptions.data.length
        "
    >
        <div style="height: 400px; width: 500px; position: relative">
            <Spin v-if="loading" fix size="large"></Spin>
            <ring-chart-center v-else :changeOptions="inListChangeOptions" />
        </div>
        <div style="height: 400px; width: 500px; position: relative">
            <Spin v-if="loading" fix size="large"></Spin>
            <ring-chart-center v-else :changeOptions="outListChangeOptions" />
        </div>
    </div>
    <spin size="large" fix v-else />
</template>

<script>
import { mapCache } from "@/plugins/vux-data-cache";
import { debounce } from "_u/helper";

import RingChartCenter from "_vc/chart/ring-chart-center";

import { financeStatistic } from "@/api/finance";

export default {
    components: {
        RingChartCenter,
    },
    data() {
        return {
            loading: false,
            inListChangeOptions: {
                titleText: "",
                seriesName: "",
                data: [],
            },
            outListChangeOptions: {
                titleText: "",
                seriesName: "",
                data: [],
            },
        };
    },
    computed: {
        ...mapCache({
            filter: "financeAnalysisIndex",
        }),
    },
    watch: {
        "filter.year"() {
            this.filterChange();
        },
        "filter.month"() {
            this.filterChange();
        },
        "filter.houseId"(val) {
            this.filterChange();
        },
    },
    methods: {
        fetch() {
            this.loading = true;
            Promise.all([
                financeStatistic({
                    houseId: this.filter.houseId,
                    year: this.filter.year,
                    month: this.filter.month,
                }),
            ])
                .then((args) => {
                    var [view] = args;
                    const inList = this.formateList(view.data.inList);
                    const outList = this.formateList(view.data.outList);
                    let str = "总";
                    if (this.filter.year) {
                        str = `${this.filter.year}年`;
                    }
                    if (this.filter.month) {
                        str += `${this.filter.month}月`;
                    }
                    this.inListChangeOptions = Object.assign(
                        this.inListChangeOptions,
                        {
                            titleText: `${str}收入统计`,
                            seriesName: str,
                            data: inList,
                        }
                    );
                    this.outListChangeOptions = Object.assign(
                        this.outListChangeOptions,
                        {
                            titleText: `${str}支出统计`,
                            seriesName: str,
                            data: outList,
                        }
                    );
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        filterChange: debounce(500, function() {
            this.fetch();
        }),
        // 格式化list
        formateList(list) {
            const newList = [];
            list.forEach((v) => {
                newList.push({
                    name: v.name,
                    value: v.amount / 100,
                });
            });
            return newList;
        },
    },
    created() {
        this.filterChange();
    },
};
</script>

<style lang="less" scoped>
.container {
    min-height: 400px;
    display: flex;
    justify-content: space-around;
    margin-top: 50px;
}
</style>
